import { useEffect, useRef, useState, useCallback } from "react";
import confetti from "canvas-confetti";
import MatchCard from "../matchCard/matchCard";
import "./final.sass";

const COLORS = ["#ff0101", "#FF6347", "#5f0404", "#eaf5ea"];

function launchExplosion() {
  const scalar = 2;
  const trophy = confetti.shapeFromText({ text: "🏆", scalar });
  const defaults = {
    spread: 360,
    ticks: 120,
    gravity: 0.3,
    decay: 0.97,
    startVelocity: 15,
    colors: COLORS,
  };

  function shoot() {
    confetti({ ...defaults, particleCount: 30, shapes: [trophy], scalar });
    confetti({ ...defaults, particleCount: 40, scalar: 1.2, shapes: ["star"] });
    confetti({ ...defaults, particleCount: 10, scalar: 0.75, shapes: ["circle"] });
  }

  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);
}

function launchRain(duration = 3000) {
  const end = Date.now() + duration;
  const scalar = 2;
  const trophy = confetti.shapeFromText({ text: "🏆", scalar });

  (function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: -0.1 },
      colors: COLORS,
      shapes: ["circle", "star"],
      gravity: 1.2,
      ticks: 200,
      decay: 0.95,
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: -0.1 },
      colors: COLORS,
      shapes: [trophy],
      scalar,
      gravity: 1.2,
      ticks: 200,
      decay: 0.95,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export default function Final({ match, onSelectWinner }) {
  const prevWinner = useRef(match?.winner);
  const [championPhase, setChampionPhase] = useState(null); // null | "enter" | "exit"

  const triggerCelebration = useCallback(() => {
    launchExplosion();
    setTimeout(() => {
      launchRain(3000);
      setChampionPhase("enter");
    }, 1500);
    setTimeout(() => setChampionPhase("exit"), 5000);
    setTimeout(() => setChampionPhase(null), 7000);
  }, []);

  useEffect(() => {
    if (match?.winner && match.winner !== prevWinner.current) {
      triggerCelebration();
    }
    // Si el ganador se limpia (reset), detener confeti
    if (!match?.winner && prevWinner.current) {
      confetti.reset();
      setChampionPhase(null);
    }
    prevWinner.current = match?.winner;
  }, [match?.winner, triggerCelebration]);

  // Limpiar confeti al desmontar (ej: al presionar reiniciar desde eliminatorias)
  useEffect(() => {
    return () => confetti.reset();
  }, []);

  if (!match) return null;

  return (
    <div className="FinalPhase">
      <div className="RoundTitleFinal"><p>FINAL</p></div>
      <MatchCard match={match} onSelectWinner={onSelectWinner} />
      {championPhase && (
        <div className="ChampionOverlay">
          <svg className={`ChampionSvg ${championPhase}`} viewBox="0 0 500 250">
            <defs>
              <path id="championArc" d="M 30,220 Q 250,20 470,220" fill="none" />
            </defs>
          </svg>
        </div>
      )}
    </div>
  );
}